module.exports = __webpack_public_path__ + "static/media/logo-header.7e89a6da.png";